import Vue from 'vue'
import request from '@/helpers/request'
import store from '@/store'

export default {
  SAVE_WORK_PLACE_SERVICE_CATEGORY: ({ commit, state }, index) => {
    const serviceCategory = state.workPlaceServiceCategories[index]
    if (serviceCategory) {
      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.workPlaces.services
          .replace('$unit_id', store.getters.workPlace.unit_id)
          .replace('$workplace_id', store.getters.workPlace.id)}`,
        {
          id: serviceCategory.id,
          type: 'category',
          enabled: serviceCategory.enabled,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          store.dispatch('SAVE_WORK_PLACE_SERVICE_CATEGORY', index + 1)
        } else {
          // TODO: Show error dialog
        }
      })
    } else {
      commit('setLoad', false)

      Vue.notify({
        group: 'hasBottomNavigation',
        title: '',
        type: 'success',
        text: Vue.config.localization.ru.savedMessage,
      })
    }
  },

  GET_UNIT_WORKPLACES({ commit, state }, unitID) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.unit_workplaces.all.replace('$1', unitID)}`,
      {
        params: {
          with: 'serviceCategories;workplaceWindows',
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const unitWorkPlaces = response.data.data

        commit('setUnitWorkPlaces', unitWorkPlaces.items)
      } else {
        // TODO: Show error dialog
      }
    })
  },
}
